module.exports = __webpack_public_path__ + "img/4.a72a182c.png";